module.exports = __webpack_public_path__ + "static/media/unrestricted-access.26a9537f.png";